import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NetworkConstant } from '../network/network-constant';
import { TELEMETRY_REQUEST } from '../network/api-type';
import type { TelemetryApiRequest, TelemetryApiResponse } from './telemetry.types';

/**
 * Sends a batch of telemetry events to `POST /api/v2/telemetry/events`.
 *
 * Uses the TELEMETRY_REQUEST context token so the auth and response interceptors
 * apply minimal, telemetry-appropriate behaviour:
 *  - Auth header: access token only (no subscriber/mobile/device identity headers).
 *  - Response: 401 pauses the drain; never triggers session logout.
 */
@Injectable({ providedIn: 'root' })
export class TelemetryApiService {
  private http = inject(HttpClient);

  async sendBatch(events: TelemetryApiRequest): Promise<TelemetryApiResponse> {
    const url = `${environment.envDomainUrl}${NetworkConstant.TELEMETRY_EVENTS}`;
    return firstValueFrom(
      this.http.post<TelemetryApiResponse>(url, events, {
        context: new HttpContext().set(TELEMETRY_REQUEST, true),
      }),
    );
  }
}
